import React from 'react';
import { styled } from '@mui/system';
import { TypographyProps } from '@mui/material';
import colors from '@/theme/colors';
import { Translate } from '../../components/Translate';
import {
  BodyLargeEmphasizedStyles,
  BodyLargeStyles,
  BodyMediumEmphasizedStyles,
  BodyMediumStyles,
  BodySmallEmphasizedStyles,
  BodySmallStyles,
  BodyLargeMidEmphasisdStyles,
  BodyMediumMidEmphasisStyles,
  BodySmallMidEmphasisStyles,
  DisplayLargeStyles,
  TitleLargeEmphasizedStyles,
  TitleLargeStyles,
  TitleMediumEmphasizedStyles,
  TitleMediumStyles,
  TitleSmallEmphasizedStyles,
  TitleSmallStyles,
  BodyMediumMidEmphasisUnderlineStyles,
  BodySmallMidEmphasisUnderlineStyles,
} from './Typography.styles';

type HTMLTags = 'span' | 'div' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'label';

type TextProps = Omit<TypographyProps, 'ref'> & {
  'data-testid'?: string;
  className?: string;
  children: React.ReactNode;
  color?: string;
  nonTranslate?: boolean;
  htmlFor?: string;
  as?: HTMLTags;
};

const Text = React.forwardRef<any, TextProps>(
  (
    {
      className,
      children,
      color = colors.prussian,
      nonTranslate = false,
      'data-testid': dataTestId,
      htmlFor,
      as: Component = 'span', // Default to 'span' if 'as' is not provided
      ...props
    },
    ref
  ) => {
    return (
      <Component
        ref={ref as any}
        className={className}
        style={{ color, userSelect: 'none', ...props.style }}
        data-testid={dataTestId}
        htmlFor={htmlFor}
        {...props}
      >
        {nonTranslate ? children : <Translate>{children}</Translate>}
      </Component>
    );
  }
);

// Styled components remain unchanged
export const BodyLargeEmphasized = styled(Text)(BodyLargeEmphasizedStyles);
export const BodyLarge = styled(Text)(BodyLargeStyles);
export const BodyMediumEmphasized = styled(Text)(BodyMediumEmphasizedStyles);
export const BodyMedium = styled(Text)(BodyMediumStyles);
export const BodySmallEmphasized = styled(Text)(BodySmallEmphasizedStyles);
export const BodySmall = styled(Text)(BodySmallStyles);
export const DisplayLarge = styled(Text)(DisplayLargeStyles);
export const BodyLargeMidEmphasis = styled(Text)(BodyLargeMidEmphasisdStyles);
export const BodyMediumMidEmphasis = styled(Text)(BodyMediumMidEmphasisStyles);
export const BodyMediumMidEmphasisUnderline = styled(Text)(BodyMediumMidEmphasisUnderlineStyles);
export const BodySmallMidEmphasis = styled(Text)(BodySmallMidEmphasisStyles);
export const BodySmallMidEmphasisUnderline = styled(Text)(BodySmallMidEmphasisUnderlineStyles);
export const TitleLargeEmphasized = styled(Text)(TitleLargeEmphasizedStyles);
export const TitleLarge = styled(Text)(TitleLargeStyles);
export const TitleMediumEmphasized = styled(Text)(TitleMediumEmphasizedStyles);
export const TitleMedium = styled(Text)(TitleMediumStyles);
export const TitleSmallEmphasized = styled(Text)(TitleSmallEmphasizedStyles);
export const TitleSmall = styled(Text)(TitleSmallStyles);
